import { Component } from '@angular/core';
import { Video } from 'src/app/models/video.model';

export const SHARED_DECISION_MAKING_VIDEOS: Video[] = [
        {
            topic: 'Understanding Shared Decision Making',
            text: '',
            bullets: [
                'Click the play button on the bottom left to continue',
                'Click on the square icon to view in full screen',
            ],
            videoLength: '3.29',
            url: 'https://firebasestorage.googleapis.com/v0/b/patient-academy.appspot.com/o/shared-decision-making%2FSHARED%20DECISION%20MAKING%20Understanding%20Shared%20Decision%20Making%20.mp4?alt=media&token=d0541f67-97d6-4284-aafb-0bb3072c98fa',
            poster: 'assets/img/shared-decision-making/1.png',
            videoNumber: 1,
        },
        {
            topic: 'Polypharmacy and Adherence',
            text: '',
            bullets: [
                'Click the play button on the bottom left to continue',
                'Click on the square icon to view in full screen',
            ],
            videoLength: '5.26',
            url: 'https://firebasestorage.googleapis.com/v0/b/patient-academy.appspot.com/o/shared-decision-making%2FSHARED%20DECISION%20MAKING%20Polypharmacy%20and%20Adherence.mp4?alt=media&token=6ed948b9-6d7e-46a7-9e58-6fec67fb055c',
            poster: 'assets/img/shared-decision-making/2.png',
            videoNumber: 1,
        },
        {
            topic: 'Patient Safety',
            text: '',
            bullets: [
                'Click the play button on the bottom left to continue',
                'Click on the square icon to view in full screen',
            ],
            videoLength: '5.09',
            url: 'https://firebasestorage.googleapis.com/v0/b/patient-academy.appspot.com/o/shared-decision-making%2FPATIENT%20SAFETY%20VIDEO%2031May23.mp4?alt=media&token=dff18944-bcfa-4c74-a122-6aeac5a1db15',
            poster: 'assets/img/banner/modules.jpg',
            videoNumber: 1,
        },
        {
            topic: 'Understanding Medicines Regulation',
            text: '',
            bullets: [
                'Click the play button on the bottom left to continue',
                'Click on the square icon to view in full screen',
            ],
            videoLength: '2.42',
            url: 'https://firebasestorage.googleapis.com/v0/b/patient-academy.appspot.com/o/shared-decision-making%2F1.UNDERSTANDING%20MEDICINES%20REGULATION%2010%20Nov%2025.mp4?alt=media&token=3cc0eed8-76c7-4344-af24-801f2aef695f',
            poster: 'assets/img/shared-decision-making/understanding-medicines-regulation.png',
            videoNumber: 1,
        },
        {
            topic: 'Social Participation',
            text: '',
            bullets: [
                'Click the play button on the bottom left to continue',
                'Click on the square icon to view in full screen',
            ],
            videoLength: '3.07',
            url: 'https://firebasestorage.googleapis.com/v0/b/patient-academy.appspot.com/o/shared-decision-making%2F2.VIATRIS%20SOCIAL%20PARTICIPATION%2010%20Nov%2025.mp4?alt=media&token=2a89e44c-d1ff-4f88-a0db-b6456b3a1c50',
            poster: 'assets/img/shared-decision-making/social-participation.png',
            videoNumber: 1,
        },
        {
            topic: 'Unmet Patient Needs',
            text: '',
            bullets: [
                'Click the play button on the bottom left to continue',
                'Click on the square icon to view in full screen',
            ],
            videoLength: '2.23',
            url: 'https://firebasestorage.googleapis.com/v0/b/patient-academy.appspot.com/o/shared-decision-making%2F3.UNMET%20PATIENT%20NEEDS%20VIDEO%2010%20Nov%2025.mp4?alt=media&token=596b9420-83cb-4080-b5f2-234f8e09fb8f',
            poster: 'assets/img/shared-decision-making/unmet-patient-needs.png',
            videoNumber: 1,
        },
        // {
        //     topic: 'Dr. Naim Aoun',
        //     text: 'Dr Naim Aoun helps you get a better understanding of COPD in the Middle East',
        //     bullets: [
        //         'Click the play button on the bottom left to continue',
        //         'Click on the square icon to view in full screen',
        //     ],
        //     videoLength: '7.27',
        //     url: 'https://firebasestorage.googleapis.com/v0/b/patient-academy.appspot.com/o/respiratory%2FDR%20NAIM%20PRESENTATION%20V.2%2020April23.mp4?alt=media&token=8626730d-f7b9-4ae0-bd1c-ecc36533dc01',
        //     poster: 'assets/img/banner/respiratory-video-2.jpg',
        //     videoNumber: 1,
        // },
];

@Component({
    selector: 'app-shared-decision-making',
    templateUrl: './shared-decision-making.component.html',
    styleUrls: ['./shared-decision-making.component.scss'],
})
export class SharedDecisionMakingComponent {
    constructor() {}

    videos = SHARED_DECISION_MAKING_VIDEOS;
}
